import React, {Fragment} from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import '@project/shared/src/static/css/bootstrap4.css';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box/';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import {makeStyles} from '@material-ui/core/styles';
import MaterialUiCheckbox from "./materialUiCheckbox/materialUiCheckbox";
import {KeyboardTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider, DatePicker} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import ToogleSwitch from "./toggleSwitch/toogleSwitch";
import Select, {components} from 'react-select';
import IconButtonV2 from "../passwordManager/iconButtionv2";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import makeAnimated from 'react-select/animated';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import InsideTextfieldSwitch from "../payRoll/insideTextfieldSwitch/insideTextFieldSwitch";
import moment from "moment";
import CreatableSelect from 'react-select/creatable';
import MaterialUiRadio from "./materialUiRadio/materialUiRadio";
import PhoneInput,{isValidPhoneNumber} from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CustomReactSelect from "../acc-reco/customReactSelectComponent/customReactSelect";
import AutoComplete from "material-ui/AutoComplete";
import MultipleEmail from './multipleEmail';
const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&:hover $notchedOutline": {
          border: "1px solid #000 !important",
          outline: 'none',
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(0,0,0, .6) !important"
        },
        "&$focused $notchedOutline": {
          border: "1px solid #000 !important",
          outline: 'none',
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(0,0,0, .6) !important"
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '"Montserrat", sans-serif'
    ].join(','),
  },
});

const useStyles = makeStyles(theme => ({
  customTextField :props=>({
    margin:0,
    "& >label":{
      // background:'white',
    },
    "& .MuiSelect-icon":{
      position:"inherit",
      cursor:"pointer"
    },
    "&>div>fieldset>legend":{
      background:'white'
    },
    "& .MuiIconButton-root:focus":{
      outline:"none"
    },
    "& >div>svg":{
      right:props.iconData!==undefined?
        props.iconData.length===2?62:props.iconData.length===1?41:props.iconData.length===3?84:""
        :"",
    },
    "& .Mui-disabled":{
      background:'rgb(245 245 245)!important',
    }

  }),
  customSwitchTextField :props=>({
    "& >label":{
      // background:'white',
    },
    "& .MuiSelect-icon":{
      position:"inherit",
      cursor:"pointer"
    },
    "&>div>fieldset>legend":{
      background:'white'
    },
    "& .MuiIconButton-root:focus":{
      outline:"none"
    },
    "& >div>svg":{
      right:props.iconData!==undefined?
        props.iconData.length===2?62:props.iconData.length===1?41:props.iconData.length===3?84:""
        :"",
    },
    "& >div":{
      padding:0
    },
    "&>div>input  ":{
      width:'50%',
      paddingRight:'10px'
    },
  }),
  phoneInput:{
    // marginTop: '8px',
    // marginBottom: '4px',
    position:'relative',
    "&:hover": {
      "&>div>input": {
        border: '1px solid black',
      },
      "& .flag-dropdown": {
        border: '1px solid black',
      },
    },
    "& .form-control":{
      width:"100%",
      "&:focus":{
        border: "1px solid #000 !important",
        outline: 'none',
        boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(0,0,0, .6) !important"
      },
      height: '40px'
    }

  },
  multiSelectLabel:{
    top: '6px',
    color: 'rgba(0, 0, 0, 0.54)',
    width: 'max-content',
    zIndex: '1',
    position: 'relative',
    marginTop: '-12px',
    lineHeight: '1',
    marginLeft: '10px',
    letterSpacing: '0.00938em',
    padding: '0px 4px',
    background: 'white',
  },
  multiselect:props => ({
    position:'relative',
    borderRadius:5,
    "&:hover":{
      outline: 'none',
      boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(0,0,0, .6)!important",
      "&  .css-yk16xz-control":{
        border: "1px solid #000 !important",
      }
    },
    "& .css-1uccc91-singleValue":{
      fontFamily: '"Montserrat", sans-serif!important'
    },
    "& input:focus .css-yk16xz-control":{
      border: "1px solid #000 !important",
      outline: 'none',
      boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(0,0,0 .6) !important"
    },
    "& .multiSelectLabel":{
      zIndex: '1',
      color: 'rgba(0, 0, 0, 0.54)',
      padding: '0 4px',
      lineHeight: '1',
      letterSpacing: '0.00938em',
      background: props.labelBg!== undefined?props.labelBg:'white',
      marginLeft: '10px',
      marginTop: '-12px',
      position: 'relative',
      top: '6px',
      width: 'max-content'
    },
    "& .css-26l3qy-menu":{
      zIndex:1000,
    },
    "& .css-yk16xz-control":{
      borderRadius:props.adornment?'4px 0 0 4px':'4px',
    },
    "&:hover .css-yk16xz-control":{
      border:'1px solid'
    }
  }),
  customDatePicker:{
    "&>label":{
      left:'31px'
    },
    "&>div":{
      "&:hover":{
        "&>div>button":{
          borderRight: '1px solid black!important',
        }
      }
    },
    "&>div>fieldset>legend":{
      marginLeft:'31px',
      background:'white'
    },
    "&>div>div":{
      marginRight:'0'
    },
    "&>div>fieldset":{
      "&:focus":{
        border: "1px solid #000 !important",
        outline: 'none',
        boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(0,0,0 .6) !important"
      },
    },
    "&>div>div>button":{
      background: 'whitesmoke',
      padding: '7px',
      borderRadius: '4px 0px 0px 4px',
      right: '13px',
      borderRight: '1px solid #cacaca',
      "&:focus":{
        outline:'none'
      },
      '&:hover': {
        background:'#000',
        '& span>svg': {
          color: '#FFF'
        },
      },
    },
  },
  errorStyle:{
    color: 'red',
    float: 'left',
    padding: '0 5px',
    transform: 'translate(-5px, 6px) scale(0.75)',
    background: 'white',
    height: 'max-content',
    marginTop: '-17px',
  },
  errorPhoneStyle:{
    color: 'red',
    float: 'left',
    padding: '0 5px',
    transform: 'translate(22px, 6px) scale(0.75)',
    background: 'white',
    height: 'max-content',
    marginTop: '-23px',
  },
  singleSlecticon:{
    borderTop:'1px solid hsl(0,0%,80%)',
    borderRight:'1px solid hsl(0,0%,80%)',
    borderBottom:'1px solid hsl(0,0%,80%)',
    height:'38px',
    borderRadius:'0 4px 4px 0',
    background:'whitesmoke',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    '& .material-icons ':{
      display:'flex',
      alignItems:'center',
      height:'100%',
      cursor:'pointer'
    },
    '&:hover': {
      background:'#000',
      '& >div>span>button>span': {
        color: '#FFF'
      },
    },
  },
  phoneTextLabel:{
    zIndex: '10',
    position: 'relative',
    background: 'white',
    padding:  '0 5px',
    left: '40px',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  avatarStyle: {
    width: '35px',
    height: '35px',
    fontSize: '0.95rem',
    backgroundColor: '#2d8cb1',
  },
  radioStyles: {
    '& >div>label>span':{
      padding: theme.spacing(0.5,0,0,1),
      fontSize: '0.9rem',
    },
  },
  mobilePhoneStyle:{
    "&:hover":{
      outline: 'none',
      // boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(0,0,0, .6) !important",
      "& .PhoneInputCountry":{
        border: "1px solid #000 !important",
        borderRight:'none'
      },
      "& input":{
        border: "1px solid #000 !important",
      }
    },
    "& .PhoneInputCountry":{
      margin: '0',
      border: '1px solid #c4c4c4',
      padding: '0 8px',
      borderTopLeftRadius: '5px',
      borderBottomLeftRadius: '5px',
    },
    "& input":{
      border: '1px solid #c4c4c4',
      borderLeft: 'none',
      padding: '7px 10px',
      outline: 'none',
      borderTopRightRadius: '5px',
      borderBottomRightRadius: '5px',
      width:'100%!important'
    },
    borderRadius:5,
    position:'relative'
  },
  autoSelect:{
    height:'36px!important',
    "& >div:nth-child(1)":{
      bottom:'5px!important',
      fontFamily:'"Montserrat", sans-serif!important',
    },
    "& >input":{
      fontFamily: '"Montserrat", sans-serif!important',
      fontSize: '0.925rem',
    },
    "& >div>hr":{
      display:'none'
    }
  },
  autoSelectLabel:{
    position: 'absolute',
    top: '-12px',
    background: 'white',
    padding: '0 5px',
    color: '#a7a7a7',
  }
}));



export default function MateriaUiInputHooks(props) {

  const classes = useStyles(props);
  let inputData='';
  let iconinputprops={};
  let errDiv =<div className={classes.errorStyle}>{props.error}</div>;

  function dateMaskChange(event) {
    let newDate = moment(event.target.value).format("YYYY-MM-DD");
    if(newDate !== "Invalid date")
    {
      if(props.id > 0)
      {
        props.callBackFun(newDate, props.id);
      }
    }
    else
    {
    }

  }

  function dateMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        placeholder="DD/MM/YYYY"
        onBlur={dateMaskChange}
      />
    );
  }

  dateMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
  };

  function landLineMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={['+', '9','1', ' ',/\d/, /\d/,'-', /\d/, /\d/, /\d/,/\d/, /\d/, /\d/, '-','(', /[1-9]/, /\d/, /\d/,/\d/, ')',]}
        showMask
      />
    );
  }

  landLineMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
  };


  const iconDataDisplay=(data)=>{
    let icon='';
    if(data!==undefined){
      icon = data.map((iconData,index)=>{
        return(
          <IconButtonV2
            disable={iconData.disable}
            propsDrawer={props.propsDrawer}
            iconClick={iconData.action}
            iconSize={iconData.iconSize}
            iconName={iconData.iconName}
            tootlTip={iconData.tooltip}
            key={index}
            onHover={iconData.onHover}
          />
        );
      });
    }
    return icon;

  };

  const reactSelectIconData=(data)=>{
    let icon='';
    if(data!==undefined){
      icon = data.map((iconData,index)=>{
        return(
          <IconButtonV2
            disable={iconData.disable}
            propsDrawer={props.propsDrawer}
            iconClick={iconData.action}
            iconSize={iconData.iconSize}
            iconName={iconData.iconName}
            tootlTip={iconData.tooltip}
            key={index}
            onHover={iconData.onHover}
          />

        );
      });
    }
    return icon;
  };

  let endAdornment={
    endAdornment: <InputAdornment position="end">
      {props.adornmentText!==undefined?props.adornmentText:iconDataDisplay(props.iconData)}

    </InputAdornment>,
  };
  let startAdornment={
    startAdornment: <InputAdornment position="start">
      {props.adornmentText!==undefined?props.adornmentText:iconDataDisplay(props.iconData)}
    </InputAdornment>,
  };

  if(props.adornment) {
    iconinputprops = props.adornment ?
      props.adornmentPosition !== undefined ?
        props.adornmentPosition === 'start' ? startAdornment : endAdornment
        : endAdornment
      : iconinputprops;
  }

  const animatedComponents = makeAnimated();


  //mobile
  const changeMobile=(value, data, event, formattedValue)=>{
    let format=data.format.replace('+', '');
    let valid = format.length===formattedValue.length-1;
    props.change(value,valid,data.dialCode);
  }


  const InputElement=()=>{
    const classes = useStyles(props);
    switch (props.inputType) {
      case 'input':
        let optionData=[];
        if (props.option){
          optionData = props.option;
          optionData.sort(function(a, b){
            if(a.label.toUpperCase() < b.label.toUpperCase()) { return -1; }
            if(a.label.toUpperCase() > b.label.toUpperCase()) { return 1; }
            return 0;
          })
        }

        inputData=
          <TextField
            label={<Box>{props.label}{props.required?<Box ml={0.5} component='span' style={{color:'red'}}>*</Box> : ""}</Box>}
            variant='outlined'
            margin='dense'
            InputProps={iconinputprops}
            inputProps={{
              style: { textAlign: props.fieldAlign !== undefined ? props.fieldAlign : ""  }
            }}
            fullWidth={true}
            name={props.name}
            value={props.value}
            onChange={props.change}
            onBlur={props.blur}
            disabled={props.disable!==undefined?props.disable:false}
            type={props.type}
            size="small"
            select={props.type==='select'}
            className={classes.customTextField}
            onKeyUp={props.onKeyUpChange}
            autoFocus={props.autoFocus}
            placeholder={props.placeholder}
            InputLabelProps={{
              style: { background: '#fff',padding:'0 5px',color: 'rgba(0, 0, 0, 0.54)' },
            }}
          >
            {props.option?
              optionData.map(data => (
                <MenuItem key={props.label+data.value} value={data.value}>
                  {data.label}
                </MenuItem>
              )):""
            }
          </TextField>;
        break;


      case 'textArea':
        inputData=
          <TextField
            multiline
            rows={2}
            rowsMax={props.rowsMax}
            label={<Box>{props.label}{props.required?<Box ml={0.5} component='span' style={{color:'red'}}>*</Box> : ""}</Box>}
            variant='outlined'
            margin='dense'
            InputProps={iconinputprops}
            fullWidth={true}
            name={props.name}
            value={props.value}
            onChange={props.change}
            onBlur={props.blur}
            disabled={props.disable}
            size="small"
            className={classes.customTextField}
            InputLabelProps={{
              style: { background: '#fff',padding:'0 5px',color: 'rgba(0, 0, 0, 0.54)' },
            }}
          >
          </TextField>;
        break;

      case 'checkbox':
        inputData=
          <Box>
            <MaterialUiCheckbox
              name={props.name}
              checkStatus={props.value}
              checkClick={props.change}
              checkDisable={props.disable}
              label={props.label}
              cardStyle={props.propsDrawer}
              propsDrawer={{ ...props.propsDrawer }}
            />
          </Box>;
        break;

      case 'checkboxWithoutLabel':

        inputData=
          <span>
              <MaterialUiCheckbox
                name={props.name}
                checkStatus={props.value}
                value={props.value}
                checkClick={props.change}
                checkDisable={props.disable}
                propsDrawer={{ ...props.propsDrawer }}
              />
          </span>;
        break;

      case 'date':
        inputData=
          <MuiPickersUtilsProvider utils={DateFnsUtils} >
            <Fragment>
              <KeyboardDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                format="dd/MM/yyyy"
                placeholder="DD/MM/YYYY"
                size="small"
                margin="dense"
                invalidDateMessage=''
                className={classes.customTextField + " " +classes.customDatePicker + " w-100 customDatePicker"}
                InputAdornmentProps={{ position: "start" }}
                allowKeyboardControl={true}
                animateYearScrolling={true}
                disabled={props.disable}
                label={<Box>{props.label}{props.required?<Box ml={0.5} component='span' style={{color:'red'}}>*</Box> : ""}</Box>}
                value={props.value}
                onBlur={props.blur}
                onChange={props.change}
                disablePast={props.disablePast}
                disableFuture={props.disableFuture}
                InputLabelProps={{
                  style: { background: '#fff',padding:'0 5px',color: 'rgba(0, 0, 0, 0.54)' },
                }}
              />
            </Fragment>
          </MuiPickersUtilsProvider>;
        break;

      case 'monthYear':
        inputData=
          <MuiPickersUtilsProvider utils={DateFnsUtils} >
            <Fragment>
              <DatePicker
                disableToolbar
                inputVariant="outlined"
                views={["year", "month"]}
                label={<Box>{props.label}{props.required?<Box ml={0.5} component='span' style={{color:'red'}}>*</Box> : ""}</Box>}
                margin='dense'
                size="small"
                helperText=""
                value={new Date(props.value)}
                maxDate={new Date()}
                onChange={props.change}
                className="w-100"
                InputLabelProps={{
                  style: { background: '#fff',padding:'0 5px',color: 'rgba(0, 0, 0, 0.54)' },
                }}
              />
            </Fragment>
          </MuiPickersUtilsProvider>;
        break;

      case 'year':
        inputData=
          <MuiPickersUtilsProvider utils={DateFnsUtils} >
            <Fragment>
              <KeyboardDatePicker
                disableToolbar
                inputVariant="outlined"
                views={["year"]}
                label={<Box>{props.label}{props.required?<Box ml={0.5} component='span' style={{color:'red'}}>*</Box> : ""}</Box>}
                margin='dense'
                size="small"
                helperText=""
                disabled={props.disable}
                value={new Date(props.value)}
                maxDate={new Date()}
                onChange={props.change}
                className="w-100"
                InputLabelProps={{
                  style: { background: '#fff',padding:'0 5px',color: 'rgba(0, 0, 0, 0.54)' },
                }}
              />
            </Fragment>
          </MuiPickersUtilsProvider>;
        break;

      case 'time':
        inputData=
          <MuiPickersUtilsProvider utils={DateFnsUtils} >
            <Fragment>
              <KeyboardTimePicker
                label={props.label}
                name={props.name}
                margin='dense'
                inputVariant="outlined"
                value={props.value}
                onChange={props.change}
                className={classes.customTextField + " w-100 "}
                InputLabelProps={{
                  style: { background: '#fff',padding:'0 5px',color: 'rgba(0, 0, 0, 0.54)' },
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change time',
                }}
                placeholder="HH:MM"
                invalidDateMessage={false}
              />
            </Fragment>
          </MuiPickersUtilsProvider>;
        break;

      case 'phone':
        inputData=
          <div className={classes.phoneInput}>
            <PhoneInput
              name={props.name}
              country={'in'}
              value={props.value}
              onChange={props.change}
              onBlur={props.blur}
              countryCodeEditable={false}
              enableSearch={true}
              searchPlaceholder="Search"
            />
            <Box className="position-absolute" style={{top:'-12px'}}>
              <Typography className={classes.phoneTextLabel} variant="caption">{props.label}</Typography>
            </Box>
          </div>;

        break;

      case 'mobile':
        inputData=
          <div className={classes.mobilePhoneStyle}>
            <PhoneInput
              country='in'
              placeholder="Enter phone number"
              value={props.value}
              onChange={changeMobile}
              disabled={props.disable}
              international
              countryCallingCodeEditable={false}
              onBlur={props.blur}
              enableSearch={true}
            />
            <Box className="position-absolute" style={{top:'-12px'}}>
              <Typography className={classes.phoneTextLabel} variant="caption">{props.label}{props.required?<Box ml={0.5} component='span' style={{color:'red'}}>*</Box> : ""}</Typography>
            </Box>
          </div>;
        break;

      case 'switch':
        inputData=
          <div  className={" h-100"}>
            <div className="d-flex align-items-center h-100">
              <div className="w-100 d-flex">
                {
                  props.label!==undefined?
                    <div style={{width:'60%'}}>
                      <Typography variant="subtitle2">
                        {props.label}
                      </Typography>
                    </div>
                    :""
                }
                <div style={{width:props.label!==undefined?'40%':"100%",textAlign:props.label!==undefined?'right':'left'}} >
                  <ToogleSwitch
                    name={props.name}
                    switchToggleChecked={props.value}
                    switchToggleChange={props.change}
                    switchLabelLeft={props.switchLabelLeft}
                    switchLabelRight={props.switchLabelRight}
                  />
                </div>
              </div>
            </div>
          </div>;
        break;


      case 'multiSelect':
        let optionMultiData = props.option;
        optionMultiData.sort(function(a, b){
          if(a.label.toUpperCase() < b.label.toUpperCase()) { return -1; }
          if(a.label.toUpperCase() > b.label.toUpperCase()) { return 1; }
          return 0;
        })
        inputData=
          <div  className={classes.multiselect+ ' d-flex'} >
            <div style={{width:props.additionalIcon?'93%':'100%'}}>
              <div>

                <Typography variant="caption" color="textSecondary" display="block" className="multiSelectLabel">
                  {props.label} {props.required?<Box ml={0.5} component='span' style={{color:'red'}}>*</Box> : ""}
                </Typography>
              </div>

              {props.selectWithCheckbox === true ?

                <Select
                  label={props.label}
                  name={props.name}
                  value={props.value}
                  onChange={props.change}
                  onBlur={props.blur}
                  options={optionMultiData}
                  isMulti
                  components={{Option}}
                  isDisabled={props.disable}
                />
                :
                <Select
                  label={props.label}
                  name={props.name}
                  value={props.value}
                  onChange={props.change}
                  onBlur={props.blur}
                  options={optionMultiData}
                  isMulti
                  components={animatedComponents}
                  isDisabled={props.disable}
                />
              }
            </div>
            {
              props.additionalIcon?
                <div className="border-top border-bottom border-right bg-light" style={{width:'7%'}}>
                  <div className="d-flex align-items-center h-100">
                    <div className="w-100 text-center h-100">
                      {props.addIcon ?
                        <div style={{lineHeight:'0',height:props.viewIcon?"50%":"100%"}}>
                          <div className="d-flex align-items-center h-100">
                            <div className="w-100 text-center">
                              <i className="material-icons cursor-pointer  text-secondary" style={{fontSize:'15px',cursor:'pointer'}}
                                 onClick={props.addIconClick}
                              >
                                add
                              </i>
                            </div>
                          </div>
                        </div>
                        :""}
                      {props.viewIcon ?
                        <div style={{lineHeight:'0',height:props.addIcon?"50%":"100%"}}>
                          <div className="d-flex align-items-center h-100">
                            <div className="w-100 text-center">
                              <i className="material-icons cursor-pointer  text-secondary" style={{fontSize:'13px',cursor:'pointer'}}
                                 onClick={props.viewIconClick}
                              >
                                remove_red_eye
                              </i>
                            </div>
                          </div>
                        </div>
                        :""}
                    </div>
                  </div>
                </div>
                :" "
            }


          </div>
        break;

      case 'singleSelect':
        let optionSingleData = props.option!==undefined?props.option:[];
        optionSingleData.sort(function(a, b){
          if(a.label.toUpperCase() < b.label.toUpperCase()) { return -1; }
          if(a.label.toUpperCase() > b.label.toUpperCase()) { return 1; }
          return 0;
        })
        inputData=
          <div  className={classes.multiselect+ ' d-flex align-items-center'} >
            <div style={{width:props.adornment?'93%':'100%',borderRadius:props.adornment?'5px 0 0 5px':'5px'}}>
              <div>
                <Typography variant="caption" color="textSecondary" display="block" className="multiSelectLabel">
                  {props.label} {props.required?<Box ml={0.5} component='span' style={{color:'red'}}>*</Box> : ""}
                </Typography>
              </div>
              <Select
                label={props.label}
                name={props.name}
                value={props.value}
                onChange={props.change}
                onBlur={props.blur}
                options={optionSingleData}
                components={animatedComponents}
                isDisabled={props.disable}
                isMulti={props.isMulti!==undefined?props.type:false}
              />
            </div>
            {
              props.adornment?
                <Box className={classes.singleSlecticon} px={0.5}>
                  {reactSelectIconData(props.iconData)}
                </Box>
                :""
            }


          </div>
        break;


      case 'landLine':
        inputData=<TextField
          label={props.label}
          variant='outlined'
          margin='dense'
          InputProps={{
            inputComponent: landLineMaskCustom,
          }}
          fullWidth={true}
          name={props.name}
          value={props.value}
          size="small"
          className={classes.customTextField}
        />
        break;

      case 'file':

        inputData=
          <span >
                     <input accept="image/*" id="text-button-file" multiple="" onChange={props.change}
                            type="file" style={{display: 'none'}}/>
                      <label
                        htmlFor="text-button-file">
                             <span className="MuiButtonBase-root MuiButton-root px-3 py-1 MuiButton-outlined MuiButton-sizeSmall"
                                   tabIndex="0" role="button" aria-disabled="false">
                                 <span className="MuiButton-label">
                                     <span  className="material-icons MuiIcon-root mr-2 MuiIcon-fontSizeSmall"  aria-hidden="true">

                                     </span>{props.label}
                                 </span>
                                 <span className="MuiTouchRipple-root"/>
                             </span>
                         </label>
                  </span>


        break;

      case 'radio':

        inputData=
          <MaterialUiRadio
            radiolabel={props.label}
            radioOptions={props.option}
            radioValue={props.value}
            handleChangeRadio={props.handleChange}
            propsDrawer={props.propsDrawer}
          />

        break;

      case 'input_switch':

        inputData=
          <TextField
            label={props.label}
            variant='outlined'
            margin='dense'
            InputProps={{
              endAdornment: <InputAdornment position="start">
                <InsideTextfieldSwitch
                  name={props.name}
                  switchToggleChecked={props.value}
                  switchToggleChange={props.change}
                  switchLabelLeft={props.switchLabelLeft}
                  switchLabelRight={props.switchLabelRight}
                />
              </InputAdornment>,
            }}
            fullWidth={true}
            name={props.name}
            value={props.value}
            onChange={props.change}
            onBlur={props.blur}
            required={props.required}
            disabled={props.disable}
            type={props.type}
            size="small"
            className={classes.customSwitchTextField}
          />


        break;


      case 'creatTableSelect':

        inputData=
          <Box display="flex"  width="100%">
            <Box flexGrow={1}>
              <CreatableSelect
                components={props.components}
                inputValue={props.inputValue}
                isClearable
                isMulti
                menuIsOpen={false}
                onChange={props.change}
                onInputChange={props.onInputChange}
                onKeyDown={props.onKeyDown}
                placeholder={props.placeholder}
                value={props.value}
              />
            </Box>
            {
              props.adornment?
                <Box alignItems="center" p={0.5} className={classes.singleSlecticon}>
                  {iconDataDisplay(props.iconData)}
                </Box>
                :""
            }

          </Box>


        break;

      case 'labelAdjacentTextfield':
        inputData=
          <Box display='flex' alignItems='center' height='100%' width='100%' ml={1} justifyContent='center'>
            <Box mr={1}>
              <Typography variant='subtitle2'>
                {props.label}
              </Typography>
            </Box>
            <Box flexGrow={1} mr={1}>
              <TextField
                variant='outlined'
                margin='dense'
                InputProps={iconinputprops}
                fullWidth={true}
                name={props.name}
                value={props.value}
                onChange={props.change}
                onBlur={props.blur}
                required={props.required}
                disabled={props.disable}
                type={props.type}
                size="small"
                select={props.type==='select'}
                className={classes.customTextField}
                onKeyUp={props.onKeyUpChange}
                autoFocus={props.autoFocus}
              >
                {props.option?
                  props.option.map(data => (
                    <MenuItem key={props.label+data.value} value={data.value}>
                      {data.label}
                    </MenuItem>
                  )):""
                }
              </TextField>
            </Box>
          </Box>
        break;

      case 'customReactSelect':
        inputData=
          <Box  display="flex" alignItems="center" className={classes.multiselect} style={{border:'1px solid #cccccc',borderRadius:5,background:'white'}}>
            <Box flexGrow={1} style={{borderRadius:props.adornment?'5px 0 0 5px':'5px'}}>
              <CustomReactSelect
                label={props.label}
                name={props.name}
                value={props.value}
                change={props.change}
                options={props.option}
                isDisabled={props.disable}
                customFieldToggle={props.customFieldToggle}
                keyParameter={props.name}
                customDropDownToggleStatus={props.customDropDownToggleStatus}
              />
            </Box>
            {
              props.adornment?
                <Box px={0.6}>
                  {reactSelectIconData(props.iconData)}
                </Box>
                :""
            }


          </Box>
        break;

      case ('autoSelect'):
        inputData =
          <Box className="border rounded" px={1} style={{position:'relative'}}>
            <Box className={classes.autoSelectLabel}>
              <Typography variant="caption">
                {props.label} {props.required?<Box component={'span'} style={{color:'red'}}>*</Box>:""}
              </Typography>
            </Box>
            <AutoComplete
              hintText={props.label}
              searchText={props.value}
              onUpdateInput={props.onUpdateInput}
              //onNewRequest={this.props.onNewRequest}
              dataSource={props.list}
              filter={(dataSource, searchText) => ((searchText).indexOf(dataSource) !== -1)}
              openOnFocus={true}
              fullWidth={'100'}
              className={classes.autoSelect}
            />
          </Box>;
        break;

      case 'multipleEmail':
        inputData=
            <MultipleEmail
                label={props.label}
                required={props.required}
                value={props.value}
                change={props.change}

            />
        break;


      default:
        break;
    }
    return (<div>
      {inputData}
      {errDiv}
    </div>);
  };

  const Option = props => {
    return (
      components.Option && <components.Option {...props}>
        <Box display="flex" width={1} alignItems="center">
          <Box flexGrow={1}>
            <Box display="inline-flex">
              <Box display="flex" alignItems="center" pr={1}>
                <Box textAlign="center" width={1}>
                  <Avatar src={props.selectWithCheckboxAvatar !== '' ? props.selectWithCheckboxAvatar : ""} className={classes.avatarStyle}/>
                </Box>
              </Box>
              <Box display="flex" alignItems="center" pr={1}>
                <Typography variant="subtitle2" color="primary">
                  <Box> {props.label}  </Box>
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <MaterialUiCheckbox
              cardStyle={props.propsDrawer}
              checkStatus={props.checkStatus}
              checkClick={props.checkClick}
            />
          </Box>
        </Box>
        <Divider style={{margin:theme.spacing(0,-1.5)}}/>
      </components.Option>
    );
  }

  return (
    <div >
      <MuiThemeProvider theme={theme}>
        {InputElement()}
      </MuiThemeProvider>

    </div>
  );
}

